import uuid from 'uuid-random';
import { addPopupAction, LAYER } from 'js/components/common/PopupManager';

import { DataVerificationStatusPopup } from '../DataVerificationStatusPopup';

export const dataVerificationStatusPopupId = uuid();

export const showDataVerificationStatusPopupAction = () => addPopupAction({
    isModal: true,
    id: dataVerificationStatusPopupId,
    layer: LAYER.DATA_VERIFICATION, // should be lower than SESSION_VALIDATION because of possible 2FA on inner component
    component: DataVerificationStatusPopup
});
